<template lang="pug">
el-dialog.vendor-info-reminder(
  visible
  @close="close")
  .background
    .blob(v-image="'/img/vendor.info.reminder.webp?pod'")

  .content
    p As we kick off an exciting new year, please take a moment to review and update any outdated information for your brand and products. Keeping this information current helps us maintain smooth operations and compliance.
    p Here’s what to double-check:
    ul.links
      li
        nuxt-link(:to= "{ name: 'vendors-settings-general', query: { silent: true } }" target="_blank")
          | Certificate of Insurance or W-9 form
          i.bx.bx-link-external.ml-1
      li
        nuxt-link(:to="{ name: 'vendors-brands', query: { silent: true } }" target="_blank")
          | Brand information
          i.bx.bx-link-external.ml-1
      li
        nuxt-link(:to="{ name: 'vendors-products', query: { silent: true } }" target="_blank")
          | Product details (e.g. manufacture locations, product attributes, or quality details)
          i.bx.bx-link-external.ml-1

    p Thank you for helping us start the year strong and ensuring everything stays up to date!

    el-checkbox.toggler(v-model="hidden" label="Never show this again")
</template>

<script>
export default {
  name: 'VendorInfoUpdateReminderModal',

  data () {
    return {
      hidden: false
    }
  },

  methods: {
    close () {
      this.$emit('done', this.hidden)
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.vendor-info-reminder {
  padding: 0;
  ::v-deep {
    .el-dialog {
      border-radius: $--radius-sm;
      max-width: 520px;
      position: relative;
      overflow: hidden;
      @include media(xs-only) {
        max-width: 320px;
      }
      &__header {
        position: absolute;
        width: 100%;
        left: 0;
        right: 0;
        top: 0;
        z-index: 2;
      }
      &__body {
        padding: 0;
      }
    }
  }
}
.background {
  position: relative;
  width: 100%;

  .blob {
    width: 100%;
    height: 240px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    @include media(xs-only) {
      height: 200px;
    }
  }
}
.content {
  position: relative;
  z-index: 1;
  padding: 20px;
  word-break: break-word;
  p {
    font-size: 13px;
    color: $--color-text-secondary;
    line-height: 1.5em;
  }
  .links {
    list-style: none;
    padding: 0;
    margin: 16px 0;
    li {
      margin-bottom: 8px;
      padding-left: 20px;
      position: relative;

      &::before {
        content: '•';
        position: absolute;
        left: 0;
        color: $--color-primary;
        font-weight: $--font-weight-bold;
        font-size: 14px;
      }

      a {
        color: $--color-primary;
        text-decoration: underline;

        &:hover {
          color: darken($--color-primary, 10%);
        }
      }
    }
  }
  .toggler {
    font-size: 13px;
    margin-top: 1em;
    ::v-deep {
      .el-checkbox {
        &__label {
          font-size: 13px;
        }
      }
    }
  }
}
</style>
